import { render } from "./GoogleTagManager.vue?vue&type=template&id=48933875"
import script from "./GoogleTagManager.vue?vue&type=script&lang=js"
export * from "./GoogleTagManager.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__